import { Log } from 'utils/logger'

const BASE_KEY = 'upspace'

export const loadState = (key: string) => {
  const stateKey = BASE_KEY + key

  try {
    const serializedState = localStorage.getItem(stateKey.toString())
    if (serializedState === null) return undefined

    return JSON.parse(serializedState)
  } catch (err) {
    Log.fatal(`Error loading ${stateKey} state to local storage.`, err)
    return err
  }
}

export const saveState = (key: string, state: any): any => {
  const stateKey = BASE_KEY + key

  try {
    const serializedState = JSON.stringify(state)
    localStorage.setItem(stateKey, serializedState)
    loadState(stateKey.toString())
    return true
  } catch (err) {
    Log.fatal(`Error saving ${stateKey} state to local storage.`, err)
    return err
  }
}
